<script setup lang="ts">
import { defineProps } from "vue";
import sooiPo from "@/assets/calculators/room-mapping/sooi_po.svg";
import taiShoo from "@/assets/calculators/room-mapping/tai_shoo.svg";
import yearSha from "@/assets/calculators/room-mapping/year_sha.svg";
import monthSha from "@/assets/calculators/room-mapping/month_sha.svg";
import taiYan from "@/assets/calculators/room-mapping/tai_yan.svg";
import taiYin from "@/assets/calculators/room-mapping/tai_yin.svg";
import nobleHappy from "@/assets/calculators/room-mapping/noble_happy.svg";
import nobleDragon from "@/assets/calculators/room-mapping/noble_dragon.svg";
import DiagramImageComponent from "@/views/Calculators/ApartmentPlan/components/stage/DiagramImageComponent.vue";
import { AptDateParamsResponse, IImageConfig } from "@/types/apartmentPlan";
import { ToggleKey } from "@/constants/apartmentPlan";

defineProps<{
  diagramConfig: IImageConfig | null;
  diagramDateParams: AptDateParamsResponse | undefined;
  toggles: Record<ToggleKey, boolean>;
}>();
</script>

<template>
  <v-group>
    <v-image
      v-if="diagramConfig && toggles['sectors-diagram']"
      :config="diagramConfig"
    />
    <DiagramImageComponent
      v-if="diagramDateParams && toggles['sui-po']"
      :diagramComponent="sooiPo"
      :diagramConfig="diagramConfig"
      :rotationOffset="diagramDateParams.sui_po"
    />
    <DiagramImageComponent
      v-if="diagramDateParams && toggles['tai-shoo']"
      :diagramComponent="taiShoo"
      :diagramConfig="diagramConfig"
      :rotationOffset="diagramDateParams.tai_shoo"
    />
    <DiagramImageComponent
      v-if="diagramDateParams && toggles['year-sha']"
      :diagramComponent="yearSha"
      :diagramConfig="diagramConfig"
      :rotationOffset="diagramDateParams.year_sha"
    />
    <DiagramImageComponent
      v-if="
        diagramDateParams && diagramDateParams.month_sha && toggles['month-sha']
      "
      :diagramComponent="monthSha"
      :diagramConfig="diagramConfig"
      :rotationOffset="diagramDateParams.month_sha"
    />
    <DiagramImageComponent
      v-if="diagramDateParams && toggles['noble-stars']"
      :diagramComponent="taiYan"
      :diagramConfig="diagramConfig"
      :rotationOffset="diagramDateParams.tai_yan"
    />
    <DiagramImageComponent
      v-if="diagramDateParams && toggles['noble-stars']"
      :diagramComponent="taiYin"
      :diagramConfig="diagramConfig"
      :rotationOffset="diagramDateParams.tai_yin"
    />
    <DiagramImageComponent
      v-if="diagramDateParams && toggles['noble-stars']"
      :diagramComponent="nobleDragon"
      :diagramConfig="diagramConfig"
      :rotationOffset="diagramDateParams.noble_dragon"
    />
    <DiagramImageComponent
      v-if="diagramDateParams && toggles['noble-stars']"
      :diagramComponent="nobleHappy"
      :diagramConfig="diagramConfig"
      :rotationOffset="diagramDateParams.noble_happy"
    />
  </v-group>
</template>
